import { apiClient } from "./apiClient";

export interface WelcomeEmailRequest {
  customerName: string;
  customerEmail: string;
}

export const authService = {
  // Send welcome email after user signs up
  sendWelcomeEmail: async (data: WelcomeEmailRequest): Promise<void> => {
    return apiClient.post<void>("/auth/welcome-email", data, false);
  },
};
